var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-notify"},[_c('div',{staticClass:"maintenance-notify__content"},[_c('p',{staticClass:"maintenance-notify__text"},[_vm._v("Platform maintenance is currently in progress.")]),_c('p',{staticClass:"maintenance-notify__text maintenance-notify__text--highlight"},[_vm._v(" Scanning is temporarily disabled. ")])])])
}]

export { render, staticRenderFns }